module.exports = __webpack_public_path__ + "img/items-grid-media.4a9a72c1.png";